

//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum ScheduledStatus {

  Closed = 0,

  Open = 1,

  Booked = 2,

  BookedByHipcamp = 5,

}

export default ScheduledStatus;